/* eslint-disable import/no-unresolved */
import once from 'lodash/once';
import { integrations as experimentIntegrations } from '../data-stores/ExperimentStore';
import { integrations as ladingIntegrations } from '../data-stores/LandingStore';
import { interval } from '../vendor/splitmetrics-track';
import trackAnyAction from './track-event/any-action';
import trackPageInaction, { EVENT_NAME as EVENT_PAGE_INACTION } from './track-event/page-inaction';
import onAnyAction from './dom/on-any-action';
import onScrollProgress from './dom/on-scroll-progress';
import trackPageScrolling from './track-event/page-scrolling';
import initIntegrations from './tracking-integrations';
import onReady from './dom/on-ready';



export default once(() => {
  initIntegrations(experimentIntegrations.length ? experimentIntegrations : ladingIntegrations);

  onReady(() => {
    onScrollProgress((scrollParams, time) => {
      trackPageScrolling(scrollParams, !time);
    }, { initial: true }); // need to be before any-action

    const cleanAnyAction = onAnyAction(once(() => {
      cleanAnyAction();
      trackAnyAction();
    }));

    interval((count) => 10000 * count + 10000).onInaction((intervalParams) => {
      trackPageInaction(intervalParams);
    }, EVENT_PAGE_INACTION);
  });
});



// WEBPACK FOOTER //
// ./src/lib/init-tracking.js